import classNames from 'classnames';
import type { FC } from 'react';
import { useCallback, useMemo, useState } from 'react';

export interface ILockBtnProps {
  isDisabled?: boolean;
  isLoading?: boolean;
  isLocked?: boolean;
  tabIndex?: number;
  e2e?: string;
  onLockChanged?: (locked: boolean) => void;
  isDelegated?: boolean;
  className?: string;
}

export const LockBtn: FC<ILockBtnProps> = ({ isDelegated = false, className, ...props }) => {
  const { onLockChanged } = props;
  const [managedIsLocked, setManagedIsLocked] = useState<boolean>(props.isLocked === undefined ? true : props.isLocked);
  const isLocked = isDelegated ? props.isLocked : managedIsLocked;
  const dataE2eForLockedState = useMemo(() => {
    return `${props.e2e}-lock`;
  }, [props.e2e]);

  const dataE2eForUnLockedState = useMemo(() => {
    return `${props.e2e}-unlock`;
  }, [props.e2e]);

  const onButtonClicked = useCallback((): void => {
    const newValue = !isLocked;
    if (!isDelegated) {
      setManagedIsLocked(newValue);
    }
    if (onLockChanged) {
      onLockChanged(newValue);
    }
  }, [isLocked, onLockChanged, isDelegated]);

  return (
    <button
      data-e2e="lock-unlock-button"
      className={classNames('btn btn-icon btn-discreet-secondary px-4', className)}
      type="button"
      role="tooltip"
      onClick={onButtonClicked}
      disabled={props.isDisabled || props.isLoading}
      tabIndex={props.tabIndex}
    >
      <i data-e2e={isLocked ? dataE2eForLockedState : dataE2eForUnLockedState} className="icon icon-sm">
        {isLocked ? 'lock' : 'lock_open'}
      </i>
    </button>
  );
};
